module.exports = __webpack_public_path__ + "img/t.82baa997.png";